"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const OPENAPI_SPECIFICATION = 'https://app.swaggerhub.com/apiproxy/registry/Crunchbase/crunchbase-enterprise_api/1.0.3';
const BASE_URL = 'https://api.crunchbase.com/api/v4';
class CrunchbaseHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub, }) {
        config.source = OPENAPI_SPECIFICATION;
        config.baseUrl = BASE_URL;
        config.operationHeaders = {
            'X-cb-user-key': config.userKey,
        };
        config.schemaHeaders = {
            'X-cb-user-key': config.userKey,
        };
        super({ name, config, cache, pubsub });
    }
}
exports.default = CrunchbaseHandler;
//# sourceMappingURL=handler.js.map